<template>

  <div v-if="IsGraficoModulabile" style="height: 20px; width: 20px; background-color: grey; position: relative; top: 3px; left: 96%; display: flex; align-content: center; justify-content: center; align-items:center; pointer-events: all; cursor: pointer" @click="MenuImpostazioni = !MenuImpostazioni">
    <a class="fa fa-bars" :title="this.GetTraduzioneLabel('Generic','TKN_IMP_GRAF',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>  
    <div v-if="MenuImpostazioni && IsGraficoModulabile" style="width: 20px; position: absolute; top: 25px; pointer-events: all">
      <div class="ZMGraficoGenericoBottoni" @click="EsportaComePDF()">
        <a class="fa fa-file-pdf-o" :title="this.GetTraduzioneLabel('Generic','TKN_EXP_PDF',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
    </div>
  </div> 

  <div ref="ElementoGrafico">  
    <canvas ref="Canvas" :width="WidthGrafico" :height="HeightGrafico + 50"></canvas>
  </div>    

</template>

<script>
import { TZGraphLine } from '@/utils/ZGraph.js'
import { TZGraphNotchType, TZGraphLabelType } from '@/utils/ZGraph.js'
import { TZDateFunct } from '@/utils/ZDateFunct'
import { TInfoGraphic } from '../../InfoGraphic.js'
import { TZMathFunct } from '@/utils/ZMathFunct'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import MixInsGraficiStorici from '@/views/ContentPages/MixInsGraficiStorici'
import { TZGenericFunct } from '@/utils/ZGenericFunct'
import { TIPOLOGIA_GRAFICI_STORICI, SystemInformation, SPESSORE_LINEE_GRAFICI } from '../../SystemInformation'

export default 
{
  components: { },
  mixins: [ MixInsGestioneTraduzioni, MixInsGraficiStorici ],
  data() 
  {
    return {
              ObjGrafico       : null,
              ObjDati          : null,
              Stacking         : 10,
              MenuImpostazioni : false,
              LinguaUtente     : SystemInformation.UserInformation.Lingua,
              TipiStorici      : TIPOLOGIA_GRAFICI_STORICI,
              SpessoreGrafico  : SPESSORE_LINEE_GRAFICI,
              Grafici          : {}
           }

  },
  props: [ 
            "WidthGrafico", 
            "HeightGrafico", 
            "ListaModuli", 
            "ObjDal", 
            "ObjAl", 
            "TipoGrafico", 
            "PropsGrafico", 
            "Repaint", 
            "DescrizioneSitoPDF",
            "IsGraficoModulabile",
            "OggettoDati", 
            "Modulo", 
            "AddDatiPDF",
            "CatenaInfo",
            "GraficiChange", 
         ],
  methods:
  {

    Adatta(MaxAsseY, MinAsseY, UdmY)
    {
      //Asse X
      this.ObjGrafico.AxisX.Min           = Date.parse(this.ObjDal.Data + 'T' + (this.ObjDal.Ora < 10? '0' + this.ObjDal.Ora : this.ObjDal.Ora) + ':00')
      this.ObjGrafico.AxisX.Max           = Date.parse(this.ObjAl.Data + 'T' + (this.ObjAl.Ora < 10? '0' + this.ObjAl.Ora : this.ObjAl.Ora) + ':00')
      this.ObjGrafico.AxisX.Max           = this.ObjGrafico.AxisX.Max + TZDateFunct.GetNHoursInTimeStamp(1)
      this.ObjGrafico.AxisX.NotchDim      = (Math.abs(this.ObjGrafico.AxisX.Max - this.ObjGrafico.AxisX.Min))
      this.ObjGrafico.AxisX.NotchDim      = TInfoGraphic.GetAdjustedNotchDim(this.ObjGrafico.AxisX.NotchDim, 24)
      //this.ObjGrafico.AxisX.OffsetNotch   = this.ObjGrafico.AxisX.NotchDim
      this.ObjGrafico.AxisX.LabelType     = TZGraphLabelType.lblDateTime
      this.ObjGrafico.AxisX.NotchFontSize  = 13
      this.ObjGrafico.AxisY.NotchFontSize  = 13
      this.ObjGrafico.AxisX.FontSize       = 15
      this.ObjGrafico.AxisY.FontSize      = 13
      
      //Asse Y
      this.ObjGrafico.AxisY.Max           = MaxAsseY
      this.ObjGrafico.AxisY.Min           = MinAsseY
      this.ObjGrafico.AxisY.NotchDim      = UdmY
      this.ObjGrafico.AxisY.OffsetNotch   = Math.abs(MinAsseY) - TZMathFunct.GetMultiplo(Math.abs(MinAsseY), UdmY, 'Difetto')
      // this.ObjGrafico.AxisY.LabelType     = TZGraphLabelType.lblDecimi
      this.ObjGrafico.AxisY.LabelType     = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))

      setTimeout(() => { this.ObjGrafico.Paint() }, 1)
    },


    Disegna()
    {
      this.Adatta(this.PropsGrafico.AxisY.Max, this.PropsGrafico.AxisY.Min, this.PropsGrafico.AxisY.Udm)

      this.InserisciDati()
      setTimeout(() => { this.ObjGrafico.Paint()})
    },

    EsportaComePDF()
    {
      let ArrayModulo = []
      ArrayModulo.push(TZGenericFunct.GetCopyOfObject(this.Modulo))

      let ArrayOggettoGrafico = []
      ArrayOggettoGrafico.push(TZGenericFunct.GetCopyOfObject(this.GraphData.OggettoGrafico))

      this.MixInsEsportaComePDF(ArrayModulo, true, ArrayOggettoGrafico, this.Modulo.Id)

      // this.MixInsEsportaComePDF(this.Modulo, true, TZGenericFunct.GetCopyOfObject(this.GraphData.OggettoGrafico))
    },

    InserisciDati()
    {
      this.Grafici = {}
      this.ObjGrafico.ClearAllGroupPoint()
          
      for (let i = 0; i < this.ListaModuli.length; i++)
      {
        this.Grafici['Modulo' + this.ListaModuli[i].Id] = this.ObjGrafico.AddGroupPoint(1, this.PropsGrafico.ListaModuli[i].Colore, this.SpessoreGrafico, true)
        
        for (let j = 0; j < this.ListaModuli[i].Dati.length; j++)
        {
          let Dato   = this.ListaModuli[i].Dati[j]
          let XCoord = Date.parse(Dato.Data)
          this.Grafici['Modulo' + this.ListaModuli[i].Id].AddPoint(XCoord, 
                                                                   this.TipoGrafico == TIPOLOGIA_GRAFICI_STORICI.TENSIONE_ALIMENTAZIONE? 
                                                                   Dato.Tensione :
                                                                   Math.trunc(Dato.Assorbimento))
        }
      }
    },

  },

  computed:
  {
    GraphData:
    {
      get()
      {
        return this.PropsGrafico
      }
    },
    
    InfoCatena:
    {
      get()
      {
        return this.CatenaInfo
      }
    }
  },

  watch:
  {
    AddDatiPDF:
    {
      handler(NewValue)
      {
        if (NewValue != 0)
        {
          this.InfoCatena.DatiPDF.push(this.MixInsGetDatiPerPDF(true, this.Modulo, TZGenericFunct.GetCopyOfObject(this.GraphData.OggettoGrafico)))
        }
      }
    },

    Repaint:
    {
      handler()
      {
        setTimeout(() => { this.ObjGrafico.Paint()})
      }
    },

    GraficiChange:
    {
      handler()
      {
        this.Disegna()
      }
    },
  },

  mounted()
  {
    if(this.OggettoDati != null)
    {
      this.ObjDati = this.OggettoDati
      this.ObjDati.TipoGrafico = this.TipoGrafico
    }

    this.ObjGrafico  = new TZGraphLine(this.$refs.Canvas)
    this.GraphData.OggettoGrafico = this.ObjGrafico
    // this.ObjGrafico  = new TZGraph(this.$refs.Canvas)

    this.ObjGrafico.VerticalLabelAxisX  = true
    this.ObjGrafico.DrawMarkup          = false
    
    if(this.TipoGrafico == TIPOLOGIA_GRAFICI_STORICI.TENSIONE_ALIMENTAZIONE)
      this.ObjGrafico.AxisY.CenterLabel    = this.GetTraduzioneLabel('VUEComponenteGraficoTensioneAssorbimento','TKN_GRAF_TENS_ASS_TENS',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_VOLT',this.LinguaUtente) + ']'
    else this.ObjGrafico.AxisY.CenterLabel = this.GetTraduzioneLabel('VUEComponenteGraficoTensioneAssorbimento','TKN_GRAF_TENS_ASS_CORR',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIAMPERE',this.LinguaUtente) + ']'

    this.ObjGrafico.AxisX.NotchType      = TZGraphNotchType.notStandard
    this.ObjGrafico.AxisY.NotchType      = TZGraphNotchType.notStandard
    this.ObjGrafico.AxisY.LabelType      = TZGraphLabelType.lblDecimi
    if(this.ObjGrafico.AxisY.NotchDim != undefined)
      this.ObjGrafico.AxisY.LabelType    = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))
    this.ObjGrafico.AxisX.LabelType      = TZGraphLabelType.lblDateTime
    this.ObjGrafico.AxisX.NotchFontSize  = 13
    this.ObjGrafico.AxisY.NotchFontSize  = 13
    this.ObjGrafico.AxisY.FontSize       = 13
    this.ObjGrafico.AxisX.NotchPenWidth  = 1
    this.ObjGrafico.AxisY.NotchPenWidth  = 1
    this.ObjGrafico.AxisX.NotchColor     = 'grey'
    this.ObjGrafico.AxisY.NotchColor     = 'grey'
    this.ObjGrafico.__Margins.MinBottom += 40
    this.ObjGrafico.__Margins.MinLeft   += 30

    this.Disegna()
    // setTimeout(() => { this.PaintCanvas() }, 1)
  },

}
</script>